import { render, staticRenderFns } from "./invoiceDetail.vue?vue&type=template&id=798f2bc0&scoped=true&"
import script from "./invoiceDetail.vue?vue&type=script&lang=js&"
export * from "./invoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetail.vue?vue&type=style&index=0&id=798f2bc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798f2bc0",
  null
  
)

export default component.exports